export default "__VITE_ASSET__BmZ1yTnQ__"